var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIsotipo = function SvgIsotipo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.673,
    height: 44.785
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "Grupo 939"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.247 2.094c6.675 4.552 6.182 17.094-1.1 28.013l-9.676-6.6s-.109-.075-.153-.11c1.908-3.122 3.7-5.495 4.569-9.508.711-3.28-.233-5.938-1.944-7.1a4.849 4.849 0 0 0-3.108-.967 13.289 13.289 0 0 0-5.445 1.227 26.653 26.653 0 0 0-11.009 9.752 31.128 31.128 0 0 0-2.959 5.562l-.419-.285a32.659 32.659 0 0 1 4.382-9.535C11.669 1.62 23.694-3.056 31.247 2.094Z",
    "data-name": "Trazado 43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.427 42.691c-6.675-4.552-6.182-17.094 1.1-28.013l9.676 6.6s.109.074.153.109c-1.908 3.122-3.7 5.5-4.57 9.508-.71 3.28.234 5.939 1.945 7.1a4.844 4.844 0 0 0 3.108.967 13.276 13.276 0 0 0 5.445-1.227 26.646 26.646 0 0 0 11.009-9.752 31.128 31.128 0 0 0 2.959-5.562l.418.285a32.607 32.607 0 0 1-4.382 9.535c-7.281 10.92-19.308 15.601-26.861 10.45Z",
    "data-name": "Trazado 44"
  }))));
};
export default SvgIsotipo;